export const blockIconsAlertWarningAmber = (
	<span className='material-symbols-outlined'>warning_amber</span>
);
